<template>
  <div>
<!--  <el-tab-pane label="车型列表" name="modelList">-->
<!--    <el-row v-show="showFilters">-->
      <!--查询条件-->
      <el-form :model="modelSearchForm" ref="modelSearchForm" size="mini" :inline="true" :rules="searchFormRules">
        <el-col :span="3">
          <el-form-item prop="brand">
            <el-input placeholder="品牌" v-model="modelSearchForm.brand" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item prop="model">
            <el-input placeholder="车型" v-model="modelSearchForm.model" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="1.5">
          <el-form-item>
            <el-button size="mini" type="primary" @click="resetSearchForm">清空</el-button>
          </el-form-item>
        </el-col>
        <el-col :span="1.5">
          <el-form-item>
            <el-button size="mini" type="primary" @click="search"
                       :loading="getModelsLoading">查询
            </el-button>
          </el-form-item>
        </el-col>
        <el-col :span="1.5">
          <el-form-item>
            <el-button size="mini" type="primary" @click="modelAdd" icon="el-icon-plus" class="el-btn"
                       v-if="checkPermission(['bee:res:model:saveOrUpdateModel'])">
              新增车型
            </el-button>
          </el-form-item>
        </el-col>
      </el-form>
<!--    </el-row>-->
    <!--列表数据-->
    <el-table :data="modelTableData" stripe style="width: 100%" ref="carTable" border
              @selection-change="handleSelectionChange" v-loading="carModelLoading">
      <af-table-column prop="brand" label="品牌"></af-table-column>
      <af-table-column prop="model" label="型号"></af-table-column>
      <af-table-column prop="dynamicType" label="类型"></af-table-column>
      <af-table-column prop="chargingEfficiency" label="充电效率"></af-table-column>
      <af-table-column prop="rangeOfVoyage" label="续航"></af-table-column>
      <af-table-column prop="topSpeed" label="最高时速"></af-table-column>
      <af-table-column prop="structure" label="车型结构"></af-table-column>
      <af-table-column prop="updateTime" label="创建时间" :formatter="dateFormatter"></af-table-column>
      <af-table-column label="操作" width="240px">
        <template slot-scope="scope">
          <el-button size="mini" plain @click="modelEdit(scope.$index, scope.row)"
                     v-if="checkPermission(['bee:res:model:updateModel'])">编辑
          </el-button>
          <el-button size="mini" plain type="danger" @click="modelDelete(scope.$index, scope.row)"
                     v-if="checkPermission(['bee:res:model:deleteModel'])">删除
          </el-button>
        </template>
      </af-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="changeModelPage"></Pagination>
<!--  </el-tab-pane>-->
    <!-- 添加界面 -->
    <AddPage
      :form-visible="addModelFormVisible"
      @closeDialog="closeDialog"
      @afterAdd="afterAdd"
    ></AddPage>
    <EditPage
      :form-visible="editModelFormVisible"
      :selectRowData="selectRowData"
      @closeDialog="closeDialog"
      @afterEdit="afterEdit"
    ></EditPage>
  </div>
</template>

<script>
    import Pagination from "../../../../../components/Pagination";
    import carApi from "../../../api/carApi";
    import AddPage from '@/module/resourceCenter/page/car/model/add.vue';
    import EditPage from '@/module/resourceCenter/page/car/model/edit.vue';
    import {validateInput} from '../../../../../common/validator';

    export default {
        name: "list",
        data() {
            return {
                searchFormRules: {
                    brand: [
                        {validator: function (rule, value, callback) {
                                validateInput(rule, value, callback,0,10,true,true,false,true,true,false,false)
                            }, trigger: 'blur'}],
                    model: [
                        {validator: function (rule, value, callback) {
                                validateInput(rule, value, callback,0,7,true,true,true,false,false,true,false)
                            }, trigger: 'blur'}],
                },
                views: {},
                dynamicType:'',
                enumData: [{
                    carTypeData: ''
                }],
                inputVisible: false,
                inputValue: '',
                // restaurants: [],
                tableData: [{}],
                modelTableData: [{}],
                brandTableData: [{}],
                carSearchForm: {},
                modelSearchForm: {},
                brandSearchForm: {},
                listForSelectQuery: {},
                operatorForSelect: '',
                listForSelect: {},
                getCarsLoading: false,
                getBrandLoading: false,
                getModelsLoading: false,
                addForm: {},
                editForm: {},
                carsLoading: false,
                addModelForm: {},
                editModelForm: {},
                addBrandForm: {},
                editBrandForm: {},
                editTypeForm: {},
                addSubmitLoading: false,
                editSubmitLoading: false,
                carModelLoading: false,
                addModelSubmitLoading: false,
                editModelSubmitLoading: false,
                addBrandSubmitLoading: false,
                editBrandSubmitLoading: false,
                carBrandLoading: false,
                innerForm: {},
                searchTabsAddForm: {},
                addFormVisible: false,
                editFormVisible: false, // 外部对话框
                addModelFormVisible: false,
                editModelFormVisible: false,
                addBrandFormVisible: false,
                editBrandFormVisible: false,
                viewVisible: false, // 视图
                multipleSelection: [],
                activeName: 'modelList',
                innerFormName: 'coordinate',
                viewName: 'detailForm',
                showFilters: true,
                input: '',
                val_time: '', // 创建时间
                formLabelWidth: '150px',
                // 分页参数
                pageparm: {
                    t: {},
                    currentPage: 1,
                    pageSize: 10,
                    total: 0
                },
                activeNames: ['basicInformation', 'addressInformation'],
                activeName: 'modelList',
                // 选中列数据
                selectRowData: {}
            }
        },
        methods: {
            carTableClick(tab, event) {
                console.log(tab, event)
            },
            modelAdd() {
                this.$nextTick(() => {
                    this.addModelFormVisible = true
                    this.addModelForm = Object.assign({})
                })
            },
            modelEdit(index, row) {
                // this.editModelForm = Object.assign({}, row)
                // this.editModelFormVisible = true
                //
                // console.log(Object.assign({}, row))
                // console.log(this.editModelForm)
                // this.editModelForm.brand = this.editModelForm.brand
                // this.editModelForm.brandId = this.editModelForm.id
                // this.editModelForm.model = this.editModelForm.model
                // this.editModelForm.dynamicType = this.editModelForm.dynamicType
                // this.editModelForm.chargingEfficiency = this.editModelForm.chargingEfficiency
                // this.editModelForm.rangeOfVoyage = this.editModelForm.rangeOfVoyage
                // this.editModelForm.topSpeed = this.editModelForm.topSpeed
                // this.editModelForm.structure = this.editModelForm.structure
                if (row !== undefined) {
                    this.selectRowData = row

                        if(this.selectRowData.dynamicType === '纯电动') {
                            this.selectRowData.dynamicType = '0'
                        }else if(this.selectRowData.dynamicType === '混合动力'){
                            this.selectRowData.dynamicType = '1'
                        }

                        if(this.selectRowData.structure === '轿车') {
                            this.selectRowData.structure = '0'
                        }else if( this.selectRowData.structure === '跑车'){
                            this.selectRowData.structure = '1'
                        }else if( this.selectRowData.structure === '面包车'){
                            this.selectRowData.structure = '2'
                        }else if( this.selectRowData.structure === '货车'){
                            this.selectRowData.structure = '3'
                        }else if( this.selectRowData.structure === '皮卡'){
                            this.selectRowData.structure = '4'
                        }else if( this.selectRowData.structure === '其它'){
                            this.selectRowData.structure = '5'
                        }

                    this.selectRowData = this.selectRowData
                    this.editModelFormVisible = true
                }
            },
            resetSearchForm() {
                this.modelSearchForm = {}
                this.submitModelSearchForm()
            },

            submitModelSearchForm() {
                this.$refs.modelSearchForm.validate((valid) => {
                    if (!valid) {
                        return;
                    }
                    this.getModelsLoading = true
                    this.carModelLoading = true
                    this.pageparm.t = this.modelSearchForm
                    let param = Object.assign({}, this.pageparm)
                    carApi.getModels(param).then((res) => {
                        if (res.code === 0) {
                            this.pageparm.total = res.data.total
                            this.modelTableData = res.data.records
                            for (let i = 0; i < res.data.records.length; i++) {
                                if (res.data.records[i].dynamicType === '0') {
                                    this.modelTableData[i].dynamicType = '纯电动'
                                } else if (res.data.records[i].dynamicType === '1') {
                                    this.modelTableData[i].dynamicType = '混合动力'
                                }
                            }
                            for (let i = 0; i < res.data.records.length; i++) {
                                if (res.data.records[i].structure === '0') {
                                    this.modelTableData[i].structure = '轿车'
                                } else if (res.data.records[i].structure === '1') {
                                    this.modelTableData[i].structure = '跑车'
                                } else if (res.data.records[i].structure === '2') {
                                    this.modelTableData[i].structure = '面包车'
                                } else if (res.data.records[i].structure === '3') {
                                    this.modelTableData[i].structure = '货车'
                                } else if (res.data.records[i].structure === '4') {
                                    this.modelTableData[i].structure = '皮卡'
                                } else if (res.data.records[i].structure === '5') {
                                    this.modelTableData[i].structure = '其它'
                                }
                            }
                            this.modelTableData = this.modelTableData
                            // this.$message({
                            //     message: res.message,
                            //     type: 'success'
                            // })
                        } else {
                            this.$message.error(res.message)
                        }
                        console.log(this.modelTableData)
                        this.getModelsLoading = false
                        this.carModelLoading = false
                    })
                })
            },
            //查询
            search()
            {
                this.pageparm.currentPage = 1
                this.submitModelSearchForm()

            },
// 删除
            modelDelete(index, row) {
                this.$confirm('确定要删除：' + row.model + '吗?', '信息', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        this.carModelLoading = true
                        let param = {id: row.id}
                        carApi.deleteModel(param).then((res) => {
                            if (res.code === 0) {
                                this.$message({
                                    message: res.message,
                                    type: 'success'
                                })
                                this.submitModelSearchForm()
                            } else {
                                this.$message.error(res.message);

                            }

                            this.carModelLoading = false
                        })
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除！'
                        })
                    })
            },
            // 添加成功后操作
            afterAdd() {
                this.addModelFormVisible = false
                this.submitModelSearchForm()
            },
            // 编辑成功后操作
            afterEdit() {
                this.editModelFormVisible = false
                this.submitModelSearchForm()
            },
            // 关闭弹框
            closeDialog(type) {
                console.log('type:' + type)
                if (type === 'add' || type === 'update') {
                    this.addModelFormVisible  = false
                    this.editModelFormVisible  = false
                }
            },
            // 日期格式化
            dateFormatter(row, column) {
                let datetime = row.updateTime+"";
              return datetime.substring(0,10)
            },
            handleSelectionChange(val) {
                this.multipleSelection = val
            },


            changeModelPage() {
                this.submitModelSearchForm()
            },

            createFilter(queryString) {
                return (restaurant) => {
                    return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
                }
            },
            handleSelect(item) {
                console.log(item)
            }
        },
        components: {
            Pagination,
            AddPage,
            EditPage
        },
        created: function () {

        },
        mounted: function () {
            this.submitModelSearchForm()

        }
    }
</script>

<style></style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/car/model/list.vue